import React, { useState, useContext } from 'react';
import {
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBRow,
  MDBCol,
  MDBIcon
} from 'mdb-react-ui-kit';
import CommonViewLayout from '../CommonViewLayout';
import UserInformationForm from './UserInformationForm';
import ChangePasswordForm from './ChangePasswordForm';
import Appearance from './Appearance';
import { ThemeContext } from "../../../../Context/ThemeContext.js";
import "../../../../styles/dark.css";
import { UserContext } from '../../../../Context/UserContext';

export default function UserSetting() {
  const { theme } = useContext(ThemeContext);
  const [activeTab, setActiveTab] = useState('profile');
  let themeClass = ( theme === "dark" || theme === "high-contrast") ? "dark" : "";
  const { user } = useContext(UserContext);

  const handleTabClick = (tabId) => {
    if (tabId === activeTab) {
      return;
    }

    setActiveTab(tabId);
  };

  return (
    <CommonViewLayout
      headerTitle="User Setting"
      iconName="cogs"
    >
      <MDBRow>
        <MDBCol xs="12" md="3">
          <MDBTabs className='flex-column text-center'>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleTabClick('profile')} active={activeTab === 'profile'} className={themeClass}>
                <MDBIcon fas icon='user-alt' className='me-2' />Profile Information
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleTabClick('password')} active={activeTab === 'password'} className={themeClass}>
                <MDBIcon fas icon='key' className='me-2' />Change Password
              </MDBTabsLink>
            </MDBTabsItem>
            {user.isBetaParticipant == "true" && <MDBTabsItem className='mb-2'>
              <MDBTabsLink onClick={() => handleTabClick('appearance')} active={activeTab === 'appearance'}>
                <MDBIcon fas icon='adjust' className='me-2' />Appearance
              </MDBTabsLink>
            </MDBTabsItem>}
          </MDBTabs>
        </MDBCol>
        <MDBCol xs="12" md="9">
          <MDBTabsContent>
            <MDBTabsPane open={activeTab === 'profile'}>
              <UserInformationForm />
            </MDBTabsPane>
            <MDBTabsPane open={activeTab === 'password'}>
              <ChangePasswordForm />
            </MDBTabsPane>
            <MDBTabsPane open={activeTab === 'appearance'}>
              <Appearance />
            </MDBTabsPane>
          </MDBTabsContent>
        </MDBCol>
      </MDBRow>
    </CommonViewLayout>
  );
}
